<template>
  <b-form @submit.prevent="submitForm">
    <div v-if="isLoading" class="py-5 text-center"><b-spinner/></div>
    <template v-if="!isLoading && passwordPolicy">
      <div class="form-group text-secondary">{{ $t("account") }}: {{ targetUser.name }} (ID: {{ targetUser.id }})</div>

      <b-form-group :description="passwordPolicy.passwordDescription">
        <template v-slot:label>{{ $t("newPassword") }} <span class="text-danger">*</span></template>
        <b-input-group>
            <b-form-input v-model.trim="newPassword" required type="text" class="text-monospace custom-validity-fix" autocomplete="off" 
                          :minlength="passwordPolicy.minPasswordLength"
                          :maxlength="passwordPolicy.maxPasswordLength"
                          :pattern="passwordPolicy.passwordPattern"
                          @invalid.native="$event.target.setCustomValidity(passwordPolicy.passwordValidationFailedMessage)"
                          @input.native="$event.target.setCustomValidity('')"/>
            <b-input-group-append>
              <b-button class="btn-form" variant="outline-secondary" v-b-tooltip :title="$t('createRandomAccessCode')"
                        @click="setRandomPassWord">
                <b-icon-arrow-repeat/>
              </b-button>
            </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group>
        <template v-slot:label>{{ $t("confirmPassword") }} <span class="text-danger">*</span></template>
        <b-form-input type="text" class="masked-password" autocomplete="off" required v-model="confirmPassword" />
      </b-form-group>

      <div v-if="formErrorMsg" class="text-danger">{{ formErrorMsg }}</div>

      <div class="text-right pt-3">
        <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">
          {{ $t("cancel") }}
        </b-button>
        <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("saveChanges") }}</b-button>
      </div>
    </template>
  </b-form>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Vue, Prop, Emit} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import environment from "@/environment";
  import * as userService from "@/service/userService";
  import * as passwordPolicyService from "@/service/passwordPolicyService";
  import * as util from "@/service/util";

  @Component
  export default class ResetPasswordModal extends BaseComponent {

    @Prop({ required: true }) targetUser;

    isLoading = true;
    passwordPolicy = null;

    newPassword = "";
    confirmPassword = "";

    formErrorMsg = "";
    isSubmitting = false;

    // Emit decorators only
    @Emit("submitted") __submitted() {}


    mounted() {
      this.fetchPasswordPolicy();
    }

    async fetchPasswordPolicy() {
      try {
        this.isLoading = true;
        this.passwordPolicy = await passwordPolicyService.get();

      } catch (e) {
        this.toastError(e);

      } finally {
        this.isLoading = false;
      }
    }

    onClickCancel() {
      this.$bvModal.hide("reset-password-modal");
    }
    setRandomPassWord() {
      this.newPassword = util.randomPassword(10);
      this.confirmPassword = '';
      util.clearCustomValidity();
    }
    async submitForm() {
      this.formErrorMsg = null;

      if (this.newPassword !== this.confirmPassword) {
        this.formErrorMsg = this.$t("passwordsNotMatch").toString();
        return;
      }

      try {
        this.isSubmitting = true;
        await userService.resetPassword(this.targetUser.id, this.newPassword);

        this.$emit("submitted");
        this.$bvModal.hide("reset-password-modal");
        this.toastSuccessDelay(this.$t("passwordResetSuccessful").toString());

      } catch (e) {
        this.toastError(e);
      } finally {
        this.isSubmitting = false;
      }
    }

  }
</script>
